'use client';

import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { verifyEmail } from '../../redux/actions/authActions';

const VerifyEmail = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector(state => state.auth);
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [verificationStatus, setVerificationStatus] = useState('verifying'); // 'verifying', 'success', 'error'

  useEffect(() => {
    if (!token) {
      setVerificationStatus('error');
      return;
    }
    dispatch(verifyEmail(token))
      .then(() => setVerificationStatus('success'))
      .catch(() => setVerificationStatus('error'));
  }, [dispatch, token]);

  return (
    <div className="verify-email-container">
      <h2 className="auth-title">Vérification de l'adresse email</h2>

      {loading && (
        <div className="loading-spinner-container">
          <div className="spinner"></div>
          <p>Vérification de votre adresse email...</p>
        </div>
      )}

      {verificationStatus === 'success' && (
        <div className="success-container">
          <i className="material-icons success-icon">check_circle</i>
          <h3>Adresse email vérifiée !</h3>
          <p>Votre adresse email a été vérifiée avec succès. Vous pouvez maintenant vous connecter à votre compte.</p>
          <Link to="/login" className="btn btn-primary btn-block">
            Se connecter
          </Link>
        </div>
      )}

      {verificationStatus === 'error' && (
        <div className="error-container">
          <i className="material-icons error-icon">error</i>
          <h3>Échec de la vérification</h3>
          <p>{error || "Le lien de vérification est invalide ou a expiré. Veuillez demander un nouveau lien de vérification."}</p>
          <Link to="/login" className="btn btn-outline-primary">
            Retour à la connexion
          </Link>
        </div>
      )}
    </div>
  );
};

export default VerifyEmail;